import { css } from '@emotion/css';

import { FilterProps } from '@/components/Filter/types';

const GroupSearchMenuWidth = css`
  width: 56rem;
  .filter-items {
    height: 32rem;
    min-height: 32rem;
  }
`;

export const AddBlockStyles = css`
  justify-content: flex-start;
`;

export const MENU_LIST_OVERRIDES: FilterProps['overrides'] = {
  className: GroupSearchMenuWidth,
};
